module.exports = __webpack_public_path__ + "img/iloilo_a_70121.ecb64cb7.jpg";